import { addMonths, subYears } from 'date-fns';
import { ReportingPeriods } from 'further-types/lp/vehicle';
import { CalendarDay } from '../../../utils';

const REPORTING_PERIOD_CONFIG = {
  [ReportingPeriods.Quarterly]: {
    labelPrefix: 'Q',
    periodCount: 4,
    periodLengthMonths: 3,
  },
  [ReportingPeriods.HalfYearly]: {
    labelPrefix: 'H',
    periodCount: 2,
    periodLengthMonths: 6,
  },
};

const getFinancialYearStartDate = (
  date: CalendarDay,
  financialYearEndDay: number,
  financialYearEndMonth: number,
) => {
  const currentDateYear = date.toUTCDate().getUTCFullYear();
  const currentYearEndDate = new CalendarDay(
    new Date(currentDateYear, financialYearEndMonth - 1, financialYearEndDay),
  );
  const currentYearStartDate = new CalendarDay(
    new Date(
      currentDateYear,
      financialYearEndMonth - 1,
      financialYearEndDay + 1,
    ),
  );

  if (date.isAfter(currentYearEndDate)) {
    return currentYearStartDate;
  }

  return new CalendarDay(subYears(currentYearStartDate.toUTCDate(), 1));
};

const getFinancialPeriodNumber = (
  date: CalendarDay,
  financialYearEndDay: number,
  financialYearEndMonth: number,
  reportingPeriods: ReportingPeriods,
) => {
  const { periodCount, periodLengthMonths } =
    REPORTING_PERIOD_CONFIG[reportingPeriods];
  const financialYearStartDate = getFinancialYearStartDate(
    date,
    financialYearEndDay,
    financialYearEndMonth,
  ).toUTCDate();

  for (let periodNumber = periodCount; periodNumber > 1; periodNumber -= 1) {
    const periodStart = new CalendarDay(
      addMonths(
        financialYearStartDate,
        (periodNumber - 1) * periodLengthMonths,
      ),
    );

    if (date.isSameOrAfter(periodStart)) {
      return periodNumber;
    }
  }

  return 1;
};

const getFinancialPeriodLabelLines = ({
  periodEnd,
  financialYearEndDay,
  financialYearEndMonth,
  reportingPeriods,
}: {
  periodEnd: CalendarDay;
  financialYearEndDay: number;
  financialYearEndMonth: number;
  reportingPeriods: ReportingPeriods;
}) => {
  const year = periodEnd.toUTCDate().getUTCFullYear();
  const periodNumber = getFinancialPeriodNumber(
    periodEnd,
    financialYearEndDay,
    financialYearEndMonth,
    reportingPeriods,
  );
  const { labelPrefix } = REPORTING_PERIOD_CONFIG[reportingPeriods];

  return {
    yearLabel: String(year),
    periodLabel: `${labelPrefix}${periodNumber}`,
  };
};

export default getFinancialPeriodLabelLines;
